import { FC } from 'react';
import ISvgProps from '../SvgLoader/ISvgProps';

export const DowntimeMobileIcon: FC<ISvgProps> = () => {
	return (
		<svg width="139" height="227" viewBox="0 0 139 227" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g filter="url(#filter0_dd_654_187)">
				<rect x="15" y="6" width="118" height="199" rx="8" fill="#F7F9FC" />
				<rect x="15.5" y="6.5" width="117" height="198" rx="7.5" stroke="#CAD7FF" />
				<path
					d="M48 193C48 204.62 38.8003 214 27.5 214C16.1997 214 7 204.62 7 193C7 181.38 16.1997 172 27.5 172C38.8003 172 48 181.38 48 193Z"
					fill="#5977EB"
					stroke="white"
					strokeWidth="2"
				/>
				<path
					d="M21.1086 185.183C22.2269 184.786 23.5236 185.035 24.4187 185.93C25.3141 186.825 25.5628 188.122 25.1647 189.241L35 199.076L33.0761 201L23.2398 191.165C22.1215 191.563 20.8248 191.314 19.9297 190.419C19.0344 189.523 18.7857 188.226 19.1838 187.108L21.2123 189.136C21.7436 189.667 22.6049 189.667 23.1362 189.136C23.6674 188.605 23.6674 187.744 23.1362 187.212L21.1086 185.183ZM30.511 186.892L33.3968 185.288L34.6794 186.571L33.0761 189.457L31.4729 189.777L29.549 191.701L28.2665 190.419L30.1903 188.495L30.511 186.892ZM24.0981 193.946L26.0219 195.87L21.5329 200.359C21.0017 200.89 20.1403 200.89 19.6091 200.359C19.1091 199.859 19.0796 199.066 19.5208 198.532L19.6091 198.435L24.0981 193.946Z"
					fill="white"
				/>
				<path d="M15 15C15 10.5817 18.5817 7 23 7H125C129.418 7 133 10.5817 133 15V22H15V15Z" fill="#CAD7FF" />
				<circle cx="24.5" cy="14.5" r="2.5" fill="white" />
				<circle cx="31.1667" cy="14.5" r="2.5" fill="white" />
				<circle cx="37.8333" cy="14.5" r="2.5" fill="white" />
			</g>
			<rect x="24.5" y="43.5" width="99" height="21" rx="7.5" stroke="#B4B8C2" strokeDasharray="2 2" />
			<rect x="76.5" y="78.5" width="30" height="16" rx="8" stroke="#B4B8C2" strokeDasharray="2 2" />
			<rect x="76.5" y="99.5" width="30" height="16" rx="8" stroke="#B4B8C2" strokeDasharray="2 2" />
			<rect x="76.5" y="121.5" width="30" height="16" rx="8" stroke="#B4B8C2" strokeDasharray="2 2" />
			<rect x="41.5" y="78.5" width="30" height="16" rx="8" stroke="#B4B8C2" strokeDasharray="2 2" />
			<rect x="41.5" y="99.5" width="30" height="16" rx="8" stroke="#B4B8C2" strokeDasharray="2 2" />
			<rect x="41.5" y="121.5" width="30" height="16" rx="8" stroke="#B4B8C2" strokeDasharray="2 2" />
			<defs>
				<filter
					id="filter0_dd_654_187"
					x="0"
					y="0"
					width="139"
					height="227"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB">
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="6" />
					<feGaussianBlur stdDeviation="3" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0577961 0 0 0 0 0.0804438 0 0 0 0 0.185189 0 0 0 0.1 0"
					/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_654_187" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="3" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0577961 0 0 0 0 0.0804438 0 0 0 0 0.185189 0 0 0 0.12 0"
					/>
					<feBlend mode="normal" in2="effect1_dropShadow_654_187" result="effect2_dropShadow_654_187" />
					<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_654_187" result="shape" />
				</filter>
			</defs>
		</svg>
	);
};
